<template lang="html">
  <div class="admin-groups-wrapper">
    <div class="title">
      Grupe
    </div>
    <table>
      <thead>
        <tr>
          <td>naziv grupe:</td>
          <td style="width: 100px;">prikaz</td>
          <td style="width: 40px;"></td>
          <td style="width: 100px;"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="group in groups" :key="group.id">
          <td>
            {{ group.grp_name }}
          </td>
          <td>
            {{ group.grp_active === 1 ? 'Da' : 'Ne' }}
            <!-- <input type="checkbox" @change="changeGroupVisibility($event, group)" :checked="group.grp_active"> -->
          </td>
          <td>
            <div @click="openEditModal(group)" class="btn">
              Izmeni
            </div>
          </td>
          <td>
            <div @click="openConfirmationModal(group)" class="btn">
              obriši
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="action-wrapper">
      <div @click="openNewModal()" class="btn">
        Dodaj novu grupu
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminGroups',
  data () {
    return {
      groups: []
    }
  },
  mounted () {
    this.getGroups()
  },
  methods: {
    getGroups () {
      api
        .getGroupsAll()
        .then(res => {
          console.log(res)
          this.groups = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    changeGroup (group) {
      api
        .editGroup(group)
        .then(res => {
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
        .finally(() => {
          this.getGroups()
        })
    },
    openEditModal (group) {
      let modalData = {
        title: 'Izmeni grupu',
        group: group,
        ok: group => {
          this.changeGroup(group)
        }
      }
      let params = {
        modalData: modalData,
        component: 'editGroupModal'
      }
      eventBus.$emit('openModal', params)
    },
    openConfirmationModal (group) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovu grupu',
        ok: () => {
          this.deleteGroup(group)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteGroup (group) {
      api
        .deleteGroup(group.grp_id)
        .then(res => {
          this.getGroups()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    openNewModal () {
      let modalData = {
        title: 'Dodaj novu grupu',
        ok: group => {
          this.addGroup(group)
        }
      }
      let params = {
        modalData: modalData,
        component: 'addGroup'
      }
      eventBus.$emit('openModal', params)
    },
    addGroup (group) {
      api
        .addGroup(group)
        .then(res => {
          this.getGroups()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-groups-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
